import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-circle-triangle-left",
  "use": "icon-si-glyph-circle-triangle-left-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-circle-triangle-left\" id=\"icon-si-glyph-circle-triangle-left\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1024</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M9,0 C4.5808656,0 1,3.582 1,8 C1,12.418 4.5808656,16 9,16 C13.4191344,16 17,12.418 17,8 C17,3.582 13.4201468,0 9,0 L9,0 Z M11,11.8457768 C10.8141669,12.0514077 10.2261871,12.0514077 10.0393707,11.8457768 L5.14084969,8.3787435 C4.9530501,8.17311256 4.9530501,7.83932094 5.14084969,7.63369 L10.0393707,4.15422321 C10.2252038,3.94859226 10.8131837,3.94859226 11,4.15422321 L11,11.8457768 L11,11.8457768 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-circle-triangle-left.svg
// module id = SNmU
// module chunks = 62